import { PERMISSION_NAMES } from '../constants/common';

export default (permissions, authData) => {
  if (typeof permissions !== 'undefined') {
    return permissions.every(permission => {
      if (permission === PERMISSION_NAMES.GUEST) {
        return authData && !authData.auth;
      }
      if (permission === PERMISSION_NAMES.USER) {
        return !authData || authData.auth;
      }
      return false;
    });
  }
  return true;
};
